module.exports = __webpack_public_path__ + "img/eye.c6e01913.svg";